module.exports = __webpack_public_path__ + "img/lagerausbildung-3bohrungen.3491670a.jpg";